'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function GoogleAnalyticsPageView({ measurementId }: { measurementId: string }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();

  useEffect(() => {
    if (!measurementId || typeof window.gtag !== 'function') return;
    const pagePath = search ? `${pathname}?${search}` : pathname;
    window.gtag('config', measurementId, { page_path: pagePath });
  }, [measurementId, pathname, search]);

  return null;
}
